import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { UserInfo } from '../../../stores/room';
import TuiButton from '../../common/base/Button.vue';
import { useI18n } from '../../../locales';
import { roomService, TUIInvitationStatus } from '../../../services';
import TUIMessage from '../../common/base/Message/index';
import { MESSAGE_DURATION } from '../../../constants/message';
interface Props {
  userInfo: UserInfo;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberInvite',
  props: {
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo;
};

const { t } = useI18n();

const showReject = ref(false);

const handleInvite = () => {
  roomService.conferenceInvitationManager.inviteUsers({
    userIdList: [props.userInfo.userId],
  });
  TUIMessage({
    type: 'success',
    message: t('Invitation sent, waiting for members to join.'),
    duration: MESSAGE_DURATION.NORMAL,
  });
};



watch(props.userInfo, val => {
  if (val.status === TUIInvitationStatus.kRejected) {
    showReject.value = true;
    setTimeout(() => {
      showReject.value = false;
    }, 3000);
  }
});

return { __sfc: true,t, showReject, handleInvite, props, TuiButton, TUIInvitationStatus }
}

})